import { convertObjToQueryStr } from "@becon-team/becon-fe-lib/utils";
import { axiosInstance } from "libs/axiosInstance";
import {
  GetUser,
  GetUserHealthInquiry,
  GetUserHealthInquiryResponseSchema,
  GetUserInquiry,
  GetUserInquiryResponseSchema,
  GetUserResponseSchema,
  PostUserHealthInquiry,
  PutUser,
  PutUserInquiry,
  DeleteUser,
} from "./user.schema";
import { validateZodSchema } from "@becon-team/becon-fe-lib/my-zod";
import { formatAxiosConfig } from "@becon-team/becon-fe-lib/my-axios";

/** POST: 유저 정보 수정 */
export const putUser: PutUser = async (body) => {
  const serverRes = await axiosInstance.put(`/user`, body);

  return serverRes.data;
};

/** DELETE: 유저 삭제 */
export const deleteUser: DeleteUser = async (body) => {
  const serverRes = await axiosInstance.delete(`/user`, { data: body });

  return serverRes.data;
};

/** GET: 유저 조회 */
export const getUser: GetUser = async (query) => {
  const queryStr = convertObjToQueryStr(query);

  const serverRes = await axiosInstance.get(`/user?${queryStr}`);

  const validatedData = await validateZodSchema(
    serverRes.data,
    GetUserResponseSchema,
    formatAxiosConfig(serverRes.config),
  );

  return validatedData;
};

/** GET: 유저 문진 조회 */
export const getUserInquiry: GetUserInquiry = async ({ userId }) => {
  const serverRes = await axiosInstance.get(`my/user/${userId}/head-analysis/quiz/b2c`);

  const validatedData = await validateZodSchema(
    serverRes.data,
    GetUserInquiryResponseSchema,
    formatAxiosConfig(serverRes.config),
  );

  return validatedData;
};

/** PUT: 유저 문진 수정 */
export const putUserInquiry: PutUserInquiry = async ({ userId, ...body }) => {
  const serverRes = await axiosInstance.put(`my/user/${userId}/head-analysis/quiz/b2c`, body);

  return serverRes.data;
};

/** GET: 유저 건강 문진 조회 */
export const getUserHeathInquiry: GetUserHealthInquiry = async ({ userId }) => {
  const serverRes = await axiosInstance.get(`my/user/${userId}/health-inquiry`);

  const validatedData = await validateZodSchema(
    serverRes.data,
    GetUserHealthInquiryResponseSchema,
    formatAxiosConfig(serverRes.config),
  );

  return validatedData;
};

/** POST: 유저 겅강 문진 등록 */
export const postUserHeathInquiry: PostUserHealthInquiry = async ({ userId, ...body }) => {
  const serverRes = await axiosInstance.post(`my/user/${userId}/health-inquiry`, body);

  return serverRes.data;
};

/** GET: 유저 B2C 문진 조회 */
export const getB2CUserInquiry: GetUserInquiry = async ({ userId }) => {
  const serverRes = await axiosInstance.get(`/my/user/${userId}/head-analysis/quiz/b2c
`);
  const validatedData = await validateZodSchema(
    serverRes.data,
    GetUserInquiryResponseSchema,
    formatAxiosConfig(serverRes.config),
  );

  return validatedData;
};
